import { auditDashboardTheme } from "../../theme";

export const scratcherTableColumnWidths = {
  game: "21%",
  pack: "17%",
  range: "9%",
  qty: "7%",
  value: "11%",
  varianceQty: "7%",
  varianceValue: "11%",
  currentStatus: "16%",
};

export const scratcherTableContainerSx = {
  border: "1px solid #AEB8D0",
  borderRadius: "8px",
  overflowX: "auto",
  overflowY: "hidden",
  p: 0,
  bgcolor: auditDashboardTheme.colors.surface,
  scrollbarWidth: "thin",
  scrollbarColor: "rgba(163, 174, 208, 0.42) transparent",
  "&::-webkit-scrollbar": { height: 6 },
  "&::-webkit-scrollbar-thumb": { backgroundColor: "rgba(163, 174, 208, 0.42)", borderRadius: 999 },
};

export const scratcherTableSx = {
  width: "100%",
  minWidth: 0,
  tableLayout: "fixed",
  borderCollapse: "collapse",
  "&& .MuiTableBody-root .MuiTableCell-root": {
    fontSize: "13px !important",
  },
  "& tbody .MuiTableCell-root": {
    borderBottom: 0,
  },
};

export const scratcherHoverRowSx = {
  "&:hover > td, &:hover > th": {
    backgroundColor: "rgba(44, 108, 160, 0.12) !important",
  },
};

export const scratcherHoverBackground = "rgba(44, 108, 160, 0.12)";

export const scratcherHeaderCellSx = {
  padding: "8px 12px !important",
  color: auditDashboardTheme.colors.text,
  bgcolor: "#f0f2f2",
  borderBottom: `1px solid ${auditDashboardTheme.colors.lineSoft}`,
  fontSize: 12,
  fontWeight: 800,
  lineHeight: 1.2,
  textTransform: "uppercase",
  whiteSpace: "nowrap",
};

export const scratcherBodyCellSx = {
  padding: "4px 8px !important",
  color: auditDashboardTheme.colors.text,
  bgcolor: "transparent",
  borderBottom: 0,
  fontSize: "13px !important",
  fontWeight: 400,
  lineHeight: 1.2,
  verticalAlign: "middle",
  whiteSpace: "nowrap",
};

export const scratcherDollarCellSx = {
  color: auditDashboardTheme.colors.textMutedStrong,
};

export const scratcherMetricCellSx = {
  px: "8px !important",
};

export const scratcherMetricCountCellSx = {
  ...scratcherMetricCellSx,
  "& .audit-scratcher-count-value": {
    display: "inline-block",
    transform: "translateX(clamp(6px, 1.25vw, 14px))",
  },
};

export const scratcherVarianceCountCellSx = {
  ...scratcherMetricCellSx,
  "& .audit-scratcher-count-value": {
    display: "inline-block",
    transform: "translateX(clamp(6px, 1.25vw, 14px))",
  },
};

export const scratcherTotalCellSx = {
  ...scratcherBodyCellSx,
  borderTop: `1px solid ${auditDashboardTheme.colors.lineStrong}`,
  bgcolor: "#f0f2f2 !important",
  fontWeight: 700,
};

export const scratcherTotalLabelSx = {
  color: auditDashboardTheme.colors.text,
  fontSize: 13,
  fontWeight: 700,
  lineHeight: 1.1,
};

export const scratcherTotalSubSx = {
  display: "block",
  mt: "2px",
  color: auditDashboardTheme.colors.description,
  fontSize: 11,
  fontWeight: 400,
  lineHeight: 1.1,
};

export const scratcherTotalPackCountSx = {
  color: auditDashboardTheme.colors.text,
  fontSize: 13,
  fontWeight: 700,
  lineHeight: 1.2,
  whiteSpace: "nowrap",
};

export const scratcherLinkedTextSx = {
  color: auditDashboardTheme.colors.blue,
  cursor: "pointer",
  textDecoration: "underline",
  textUnderlineOffset: "2px",
  whiteSpace: "nowrap",
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.2,
  "&:focus-visible": {
    outline: `2px solid ${auditDashboardTheme.colors.blue}`,
    outlineOffset: "2px",
    borderRadius: "2px",
  },
  "&:hover, &:focus-visible": {
    textDecoration: "underline",
    textUnderlineOffset: "2px",
  },
};

export const scratcherGameTextSx = {
  display: "block",
  width: "100%",
  color: auditDashboardTheme.colors.text,
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1.2,
  textAlign: "left",
  whiteSpace: "normal",
  wordBreak: "break-word",
  cursor: "pointer",
  "&:focus-visible": {
    outline: `2px solid ${auditDashboardTheme.colors.blue}`,
    outlineOffset: "2px",
    borderRadius: "2px",
  },
  "&:hover, &:focus-visible": {
    color: auditDashboardTheme.colors.blue,
    textDecoration: "underline",
    textUnderlineOffset: "2px",
  },
};

export const scratcherGameMetaSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  mt: "2px",
  color: auditDashboardTheme.colors.textMutedStrong,
  fontSize: 12,
  fontWeight: 400,
  lineHeight: 1.05,
  whiteSpace: "nowrap",
  flexWrap: "nowrap",
};

export const scratcherManualSoldChipSx = {
  display: "inline-flex",
  alignSelf: "flex-start",
  mt: 0.5,
  px: 0.75,
  py: 0.15,
  borderRadius: 1,
  border: "1px solid #fedf89",
  bgcolor: "#fffaeb",
  color: "#b54708",
  fontSize: 10,
  fontWeight: 700,
  lineHeight: 1.3,
};

export const scratcherEmptyStateCellSx = {
  ...scratcherBodyCellSx,
  p: 0,
  height: 80,
  color: auditDashboardTheme.colors.textMutedStrong,
  fontSize: 12,
  fontWeight: 500,
  textAlign: "center",
  bgcolor: auditDashboardTheme.colors.surface,
};

export const getScratcherDividerSx = (_isLast: boolean) => ({
  borderRight: "none",
});
